const CustomCheckBox = ({ title, value, onChange, label, name }) => {
  return (
    <>
      <div className="custom-label fw-bold " style={{ color: "#CACCFC" }}>
        {title}
      </div>
      <div className="form-check mt-2  mb-1">
        <input
          data-value={value}
          checked={value}
          className="form-check-input cursor-pointer"
          type="checkbox"
          name={name}
          onChange={onChange}
          style={{ backgroundColor: "transparent", borderColor: "rgba(122, 107, 232, 1)", boxShadow: "inset 0 1px 3px rgba(0,0,0,.3)" }}
        />
        <label className="form-check-label" htmlFor="flexCheckChecked">
          {label}
        </label>
      </div>
      <div className="input-underline"></div>
    </>
  );
};

export default CustomCheckBox;
